<template>
  <div>
    <v-dialog
      v-model="localPaymentDialog"
      max-width="650"
    >
      <v-card>
        <v-card-text class="dialog-title">Выберите платежную систему</v-card-text>

        <v-card-actions class="card-actions">
          <v-progress-circular
            v-if="isLoadingMethods"
            indeterminate
            color="secondary"
          />

          <span v-else-if="methodsError" class="card-actions__text">{{ methodsError }}</span>

          <span v-else-if="!paymentMethods.length" class="card-actions__text">
            Нет доступных платежных систем
          </span>

          <v-btn
            v-for="method in paymentMethods"
            :key="method.payway"
            color="secondary"
            class="card-actions__btn"
            @click="$emit('selectedMethod', method.payway)"
          >
            {{ method.public_name }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="localConfirmationDialog"
      max-width="290"
    >
      <v-card>
        <v-card-text class="dialog-title">Вы уверены?</v-card-text>

        <v-card-actions>
          <v-spacer />

          <v-btn
            :disabled="isDisabled"
            color="green darken-1"
            flat="flat"
            @click="$emit('selectPayment')"
          >
            Подтвердить
          </v-btn>

          <v-btn
            color="red darken-1"
            flat="flat"
            @click="$emit('clear')"
          >
            Отмена
          </v-btn>

          <v-spacer />
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar
      v-model="localSnackbar"
    >
      {{ snackbarText }}
    </v-snackbar>
  </div>
</template>

<script>
import { getConfirmPaymentSystems } from '../../../api/transactions'

export default {
  name: 'PayoutsMethodsModal',
  props: ['snackbar', 'snackbarText', 'confirmationDialog',
    'isDisabled', 'paymentDialog'],
  data () {
    return {
      localSnackbar: this.snackbar,
      localConfirmationDialog: this.confirmationDialog,
      localPaymentDialog: this.paymentDialog,
      paymentMethods: [],
      isLoadingMethods: false,
      methodsError: null
    }
  },
  watch: {
    snackbar (newVal) {
      this.localSnackbar = newVal
    },
    localSnackbar (newVal) {
      this.$emit('update:snackbar', newVal)
    },
    confirmationDialog (newVal) {
      this.localConfirmationDialog = newVal
    },
    localConfirmationDialog (newVal) {
      this.$emit('update:confirmationDialog', newVal)
    },
    paymentDialog (newVal) {
      this.localPaymentDialog = newVal
    },
    localPaymentDialog (newVal) {
      this.$emit('update:paymentDialog', newVal)
      if (newVal) this.pullPaymentMethods()
    }
  },
  methods: {
    pullPaymentMethods () {
      if (this.isLoadingMethods || this.paymentMethods.length) return

      this.isLoadingMethods = true
      this.methodsError = null
      getConfirmPaymentSystems()
        .then(response => {
          this.paymentMethods = response.data.payment_systems ?? []
        })
        .catch(err => {
          this.methodsError = `Ошибка: ${err.response?.status} ${err.response?.data.message || err.message}`
        })
        .finally(() => {
          this.isLoadingMethods = false
        })
    }
  }
}
</script>

<style scoped>
.dialog-title{
  font-size: 30px;
  text-align:center;
}

.card-actions {
  flex-wrap: wrap;
  justify-content: center;
  gap: 8px;
  padding-bottom: 16px;
}

.card-actions__btn {
  margin: 0 !important;
}

.card-actions__text {
  padding-bottom: 8px;
}
</style>
